import * as Redux from "redux";

import appIntelligenceReducer from "app/pages/app-intelligence/store/reducer";
import benchmarkReducer from "app/pages/benchmark-tracker/store/reducer";
import salesWorkspace from "app/pages/workspace/sales/store/reducer";
import { appDataSource } from "app/reducers/_reducers/appIntelligenceDataSourceReducer";
import { countryFilter } from "app/reducers/_reducers/CountryFilterReducer";
import { customCategories } from "app/reducers/_reducers/customCategoriesReducer";
import { industryResearchModule } from "app/reducers/_reducers/industryResearchModuleReducer";
import primaryBar from "app/reducers/_reducers/PrimarySidebar3Reducer";
import { QueryBarReducer } from "app/reducers/_reducers/queryBarReducer";
import segmentsModule from "app/reducers/_reducers/segmentsModuleReducer";
import segmentsWizardModule from "app/reducers/_reducers/SegmentsWizardModuleReducer";
import trackerModule from "app/reducers/_reducers/trackerModuleReducer";
import { trackerFirstTimeDeleteSection } from "app/reducers/_reducers/trackerReducer";
import { usersDigitalSuiteFiltersSelection } from "app/reducers/_reducers/usersDigitalSuiteFiltersSelectionReducer";
import { usersFiltersSelection } from "app/reducers/_reducers/usersFiltersSelectionReducer";
import { WebsiteAnalysisFilters } from "app/reducers/_reducers/WebsiteAnalysisFilterReducer";

import salesIntelligenceReducer from "../pages/sales-intelligence/store/reducer";
import { commonWorkspace } from "../pages/workspace/common/reducers/common_workspace_reducer";
import { cig } from "../services/CIGService";

import common from "./_reducers/commonReducer";
import { contactUsModal } from "./_reducers/contactUsModalReducer";
import conversionModule from "./_reducers/ConversionModuleReducer";
import { customDashboard } from "./_reducers/customDashboard";
import educationBar from "./_reducers/educationBarReducer";
import impersonation from "./_reducers/impersonateReducer";
import isUserOnMobileDevice from "./_reducers/isUserOnMobileDeviceReducer";
import { keywordGeneratorToolReducer as keywordGeneratorTool } from "./_reducers/keywordGeneratorToolReducer";
import layout from "./_reducers/layoutReducer";
import leadGenerator from "./_reducers/leadGeneratorReducer";
import leadingFolderPage from "./_reducers/LeadingFolderReducer";
import popularPages from "./_reducers/popularPagesReducer";
import primaryNavOverride from "./_reducers/primaryNavOverrideReducer";
import qualificationSideBar from "./_reducers/qualificationSideBarReducer";
import routing from "./_reducers/routingReducer";
import { SearchTrackerReducer } from "./_reducers/SearchTrackerReducer";
import secondaryBar from "./_reducers/SecondaryBarReducer";
import { tableSelectionReducer } from "./_reducers/tableSelection.reducer";
import ui from "./_reducers/ui";
import universalSearch from "./_reducers/universalSearchReducer";
import { unlockModal } from "./_reducers/unlockModalReducer";
import userData from "./_reducers/userData/userDataReducer";

const { combineReducers } = Redux;

export const mainReducer = combineReducers({
    tableSelection: tableSelectionReducer,
    common,
    popularPages,
    customDashboard,
    educationBar,
    userData,
    routing,
    layout,
    ui,
    impersonation,
    leadingFolderPage,
    leadGenerator,
    universalSearch,
    cig,
    unlockModal,
    keywordGeneratorTool,
    contactUsModal,
    commonWorkspace,
    salesWorkspace,
    conversionModule,
    segmentsWizardModule,
    segmentsModule,
    trackerModule,
    WebsiteAnalysisFilters,
    usersFiltersSelection,
    usersDigitalSuiteFiltersSelection,
    secondaryBar,
    primaryNavOverride,
    appIntelligence: appIntelligenceReducer,
    salesIntelligence: salesIntelligenceReducer,
    qualificationSideBar,
    QueryBarReducer,
    appDataSource,
    countryFilter,
    trackerFirstTimeDeleteSection,
    industryResearchModule,
    primaryBar,
    SearchTrackerReducer,
    benchmarkTracker: benchmarkReducer,
    isUserOnMobileDevice,
    customCategories,
});
